import { render, staticRenderFns } from "./CompSocialNetworkReactions.vue?vue&type=template&id=8958aae2&scoped=true"
import script from "./CompSocialNetworkReactions.vue?vue&type=script&setup=true&lang=js"
export * from "./CompSocialNetworkReactions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompSocialNetworkReactions.vue?vue&type=style&index=0&id=8958aae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8958aae2",
  null
  
)

export default component.exports